import { TAB_VIEWS } from 'productTemplate/enums/buyBarMobile';

export const getBuyBarDeepLinkQueryParams = ({ query, mobileBuyBarView, expandedSize }) => {
  const queryParams = {
    ...query,
  };

  if (mobileBuyBarView === TAB_VIEWS.NONE) {
    delete queryParams.tab;
    delete queryParams.expandedSize;
  } else {
    if (mobileBuyBarView) {
      queryParams.tab = mobileBuyBarView;
    }
    if (expandedSize) {
      queryParams.expandedSize = expandedSize;
    }
  }

  delete queryParams.productTemplateSlug;
  // this prevents the Offers modal from popping up again
  delete queryParams.offerSize;

  return queryParams;
};
